import type { ThemeOptions } from "@mui/material/styles";

/**
 * Player owns the audience-specific expression of the shared semantic roles.
 * The dark scheme is the product default; the light scheme remains complete for
 * browser/OS transitions and deterministic component tests.
 */
export const PLAYER_COLOR_SCHEMES = {
  light: {
    palette: {
      secondary: { main: "#D95F52" },
      background: { default: "#F5F6F2" },
      divider: "#D8DDD4",
      text: { secondary: "#5C685D", disabled: "#737D73" },
      semantic: {
        surface: "#FFFFFF",
        onSurface: "#182019",
        primary: "#39710D",
        onPrimary: "#FFFFFF",
        selected: "#E8EFD9",
        onSelected: "#293A20",
        focus: "#075FC7",
        pending: "#916000",
        success: "#08784D",
        warning: "#916000",
        error: "#B52D27",
        conflict: "#8A3E87",
        live: "#C44237",
      },
    },
  },
  dark: {
    palette: {
      secondary: { main: "#FF8275" },
      background: { default: "#111513" },
      divider: "#303B33",
      text: { secondary: "#ADB7AE", disabled: "#78857B" },
      semantic: {
        surface: "#1B211D",
        onSurface: "#F2F5EF",
        primary: "#B7EB4B",
        onPrimary: "#172100",
        selected: "#2D3A26",
        onSelected: "#E8EFD9",
        focus: "#C9F875",
        pending: "#F4BD5F",
        success: "#52D6A1",
        warning: "#F4BD5F",
        error: "#FF8177",
        conflict: "#E6A6E3",
        live: "#FF7568",
      },
    },
  },
} satisfies ThemeOptions["colorSchemes"];
